import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import * as Styles from './sso-divider.module.scss';

function SSODivider({ message, className }) {
  return (
    <div className={classNames(Styles.root, className)}>
      <span className={Styles.line} />
      <span className={Styles.message}>
        {message === 'signin' && 'or, log in with username'}
        {message === 'signup' && 'or, sign up'}
      </span>
      <span className={Styles.line} />
    </div>
  );
}

SSODivider.propTypes = {
  message: PropTypes.oneOf(['signin', 'signup']).isRequired,
  className: PropTypes.string,
};

SSODivider.defaultProps = {
  className: null,
};

export default SSODivider;
